import Cookies from "js-cookie"; // 引用 js-cookie 用於操作 Cookies
import api from "@/assets/js/api"; // 引用 API 模組

import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出
import { parseJwt } from "@/assets/js/jwt"; // 確保你有引用

export default {
  name: "MemberCenter",
  data() {
    return {
      currentEmail: Cookies.get("email"), // 顯示當前用戶的 Email
      currentSection: "memberInfo", // 預設顯示的區塊
      member: {}, // 存儲會員資料
      currentOrderFilter: "paid", // 訂單過濾器
      orders: [], // 從後端獲取的訂單資料
      oldPassword: "", // 初始化舊密碼
      newPassword: "", // 初始化新密碼
    };
  },
  computed: {
    // 根據當前篩選條件過濾訂單
    filteredOrders() {
      return this.orders.filter(
        (order) => order.status === this.currentOrderFilter
      );
    },
  },

  methods: {
    // 格式化日期
    formatDate1(date) {
      if (!date) return "無資料";
      return new Date(date).toISOString().split("T")[0]; // 返回 YYYY-MM-DD 格式
    },

    // 切換顯示的區塊
    showSection(section) {
      this.currentSection = section;
    },
    // 設定訂單篩選條件
    filterOrders(filter) {
      this.currentOrderFilter = filter;
    },
    // 登出處理
    async handleLogout() {
      try {
        Cookies.remove("token");
        Cookies.remove("email");
        this.$router.push("/login");
      } catch (error) {
        console.error("登出失敗:", error);
        Swal.fire({
          icon: "error", // ❌ 錯誤圖示
          title: "登出失敗", // 標題
          text: "請稍後再試！", // 內容提示
          confirmButtonText: "確定", // 按鈕文字
        });
      }
    },
    async fetchMember() {
      try {
        const token = Cookies.get("token"); // 從 Cookie 取出 token

        if (!token) {
          Swal.fire({
            icon: "warning",
            title: "未登入",
            text: "請重新登入！",
          }).then(() => {
            this.$router.push("/login");
          });
          return;
        }

        const payload = parseJwt(token); // 使用你自定義的 jwt 解碼器

        if (!payload || !payload.email) {
          Swal.fire({
            icon: "warning",
            title: "Token 無效",
            text: "請重新登入！",
          }).then(() => {
            this.$router.push("/login");
          });
          return;
        }

        // 🔥 直接從 JWT 解析資料，不打後端 API
        this.member = {
          email: payload.email || "",
          fullName: payload.fullName || "",
          phone: payload.phone || "",
          birth: payload.birth || "",
        };

        console.debug("[DEBUG] 從 JWT 解析出的會員資料:", this.member);
      } catch (error) {
        console.error("[DEBUG] 解碼 token 失敗:", error);
        Swal.fire({
          icon: "error",
          title: "資料解析錯誤",
          text: "請重新登入！",
        }).then(() => {
          this.$router.push("/login");
        });
      }
    },

    async changePassword() {
      if (!this.oldPassword || !this.newPassword) {
        Swal.fire({
          icon: "warning", // 顯示警告圖示
          title: "欄位未填寫完整", // 標題
          text: "請輸入完整的舊密碼與新密碼！", // 內容文字
          confirmButtonText: "確定", // 按鈕文字
        });
        return;
      }

      const payload = {
        email: this.member.email,
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        phone: this.member.phone, // 新增電話
        birth: this.member.birth, // 新增生日
      };

      console.debug("[DEBUG] 修改密碼的 Payload:", payload);

      try {
        const token = Cookies.get("token");
        console.debug("[DEBUG] 使用的 Token:", token);

        const response = await api.post("/Member/change-password", payload);

        if (response.status === 200) {
          Swal.fire({
            icon: "success", // 顯示成功圖示
            title: "修改成功", // 標題
            text: response.data.message || "密碼修改成功！", // 顯示後端回傳訊息，或預設成功訊息
            confirmButtonText: "確定", // 按鈕文字
          });
          this.oldPassword = "";
          this.newPassword = "";
        } else {
          console.warn("[WARN] 非預期的響應:", response);
          Swal.fire({
            icon: "error", // 顯示錯誤圖示
            title: "修改失敗", // 標題
            text: response.data.message || "密碼修改失敗！", // 顯示後端回傳訊息，或預設錯誤訊息
            confirmButtonText: "確定", // 按鈕文字
          });
        }
      } catch (error) {
        if (error.response) {
          console.error("[ERROR] 後端錯誤響應:", error.response.data);
          Swal.fire({
            icon: "error", // 錯誤圖示
            title: "錯誤", // 標題
            text: error.response.data.message || "伺服器錯誤，無法修改密碼！", // 顯示後端訊息或預設內容
            confirmButtonText: "確定", // 確認按鈕文字
          });
          Swal.fire({
            icon: "error", // 錯誤圖示
            title: "後端錯誤", // 標題
            text: JSON.stringify(error.response.data), // 將後端 JSON 轉字串顯示
            confirmButtonText: "確定", // 確認按鈕
          });
        } else {
          console.error("[ERROR] 無法連接到伺服器:", error.message);
          Swal.fire({
            icon: "error", // 錯誤圖示
            title: "連線錯誤", // 標題
            text: "伺服器無法連接，請稍後再試！", // 提示內容
            confirmButtonText: "確定", // 確認按鈕
          });
        }
      }
    },

    // 格式化日期
    formatDate(date) {
      const d = new Date(date);
      return isNaN(d.getTime()) ? "無效日期" : d.toLocaleDateString("zh-TW");
    },
  },
  created() {
    this.fetchMember(); // 頁面載入時執行獲取會員資料的操作
  },
};
